import { v4 as uuidv4 } from 'uuid';
export let poseImage =
  'https://digital-human-1327410703.cos.ap-guangzhou.myqcloud.com/ai-virtual-man/6016f58a115057e9eb5755ea017d6169/20240719/7dc6eaea-b541-4440-b735-62e9dbdb117b/48ac8915ec63d7c1e3e8191ed6bd2e9c.png';
// export let poseImage =
// 'https://virtualhuman-cos-test-1251316161.cos.ap-nanjing.myqcloud.com/prod/resource-manager/small/284/2024/5005/model_14150_20231226102750/header.png';
export let defaultbg = '';
export let initData = {
  id: '',
  name: '',
  backgroundUrl: defaultbg,
  userPromo: '',
  poseImage,
  resolution: '1920x1080',
  originZoomStr: 1,
  imagePosition: -0.5,
  imagePositionVertical: 0,
  preBroadcastContent: '',
  wakeupTexts: [],
  wakeupText: '',
};

export const resetData = (programm = {}) => {
  initData = {
    id: '',
    name: '',
    backgroundUrl: defaultbg,
    poseImage,
    userPromo: '',
    resolution: '1920x1080',
    originZoomStr: 1,
    imagePosition: -0.5,
    imagePositionVertical: 0,
    preBroadcastContent: '',
    wakeupTexts: [],
    wakeupText: '',
    ...programm,
  };
};
